import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const MicrosoftOutlookIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#outlook-a)">
      <path
        fill="url(#outlook-b)"
        d="m21.01 6.12-14.5 9.302-1.247-1.99v-1.716c0-.625.313-1.207.83-1.547l8.428-5.536a3.84 3.84 0 0 1 4.222 0L21.01 6.12Z"
      />
      <path
        fill="url(#outlook-c)"
        d="M18.614 4.552c.044.026.087.053.13.081l6.577 4.319L9.013 19.415 6.51 15.42l11.97-7.694c1.133-.729 1.182-2.368.134-3.173Z"
      />
      <path
        fill="url(#outlook-d)"
        d="M18.614 4.552c.044.026.087.053.13.081l6.577 4.319L9.013 19.415 6.51 15.42l11.97-7.694c1.133-.729 1.182-2.368.134-3.173Z"
      />
      <path
        fill="url(#outlook-e)"
        d="m15.52 21.413-6.507-1.997 13.834-8.877c1.165-.747 1.162-2.469-.006-3.212l-.062-.04.18.113 4.21 2.764c.517.34.83.923.83 1.548v1.66l-12.48 8.041Z"
      />
      <path
        fill="url(#outlook-f)"
        d="m15.52 21.413-6.507-1.997 13.834-8.877c1.165-.747 1.162-2.469-.006-3.212l-.062-.04.18.113 4.21 2.764c.517.34.83.923.83 1.548v1.66l-12.48 8.041Z"
      />
      <path
        fill="url(#outlook-g)"
        d="M18.744 4.633a3.84 3.84 0 0 0-4.222 0L6.094 10.17a1.85 1.85 0 0 0-.83 1.547v.084a1.9 1.9 0 0 0 .873 1.54l10.48 6.688 10.505-6.677a1.9 1.9 0 0 0 .877-1.605v1.626-1.66a1.85 1.85 0 0 0-.83-1.547l-8.425-5.532Z"
      />
      <path
        fill="url(#outlook-h)"
        d="M14.77 27h9.28c2.18 0 3.948-1.79 3.948-3.996V11.746a1.9 1.9 0 0 1-.877 1.605l-13.806 8.775a2.595 2.595 0 0 0-1.196 2.19c0 1.482 1.186 2.683 2.65 2.683Z"
      />
      <path
        fill="url(#outlook-i)"
        d="M14.77 27h9.28c2.18 0 3.948-1.79 3.948-3.996V11.746a1.9 1.9 0 0 1-.877 1.605l-13.806 8.775a2.595 2.595 0 0 0-1.196 2.19c0 1.482 1.186 2.683 2.65 2.683Z"
      />
      <path
        fill="url(#outlook-j)"
        d="M14.77 27h9.28c2.18 0 3.948-1.79 3.948-3.996V11.746a1.9 1.9 0 0 1-.877 1.605l-13.806 8.775a2.595 2.595 0 0 0-1.196 2.19c0 1.482 1.186 2.683 2.65 2.683Z"
      />
      <path
        fill="url(#outlook-k)"
        d="M18.543 26.999H9.21c-2.18 0-3.947-1.79-3.947-3.996V11.737c0 .651.33 1.257.874 1.604l13.792 8.801a2.64 2.64 0 0 1 1.213 2.226c0 1.453-1.164 2.63-2.6 2.63Z"
      />
      <path
        fill="url(#outlook-l)"
        d="M18.543 26.999H9.21c-2.18 0-3.947-1.79-3.947-3.996V11.737c0 .651.33 1.257.874 1.604l13.792 8.801a2.64 2.64 0 0 1 1.213 2.226c0 1.453-1.164 2.63-2.6 2.63Z"
      />
      <path
        fill="url(#outlook-m)"
        d="M6.053 14.85h6c1.133 0 2.052.93 2.052 2.078v6.073c0 1.148-.919 2.078-2.053 2.078h-6C4.92 25.08 4 24.15 4 23.001v-6.073c0-1.147.919-2.077 2.053-2.077Z"
      />
      <path
        fill="url(#outlook-n)"
        d="M6.053 14.85h6c1.133 0 2.052.93 2.052 2.078v6.073c0 1.148-.919 2.078-2.053 2.078h-6C4.92 25.08 4 24.15 4 23.001v-6.073c0-1.147.919-2.077 2.053-2.077Z"
      />
      <path
        fill="#fff"
        d="M9.026 22.906c-.835 0-1.521-.265-2.057-.794-.537-.53-.805-1.22-.805-2.072 0-.9.272-1.627.817-2.182.544-.556 1.257-.834 2.138-.834.833 0 1.511.266 2.034.798.525.532.788 1.233.788 2.103 0 .895-.272 1.615-.816 2.163-.542.545-1.242.818-2.099.818Zm.025-1.123c.455 0 .822-.158 1.1-.473.277-.314.416-.752.416-1.313 0-.585-.135-1.04-.405-1.366-.27-.325-.629-.488-1.079-.488-.464 0-.837.168-1.12.504-.283.334-.424.776-.424 1.326 0 .558.141 1 .424 1.325a1.38 1.38 0 0 0 1.088.485Z"
      />
      <path
        fill="#fff"
        d="M9.024 22.984c-.832 0-1.515-.271-2.05-.815-.534-.543-.801-1.253-.801-2.128 0-.924.271-1.671.813-2.242.543-.57 1.253-.856 2.131-.856.83 0 1.505.273 2.026.82.523.546.785 1.266.785 2.16 0 .919-.271 1.66-.813 2.222-.54.56-1.237.84-2.09.84Zm.024-1.153c.454 0 .82-.162 1.096-.485.277-.324.415-.774.415-1.35 0-.6-.134-1.068-.403-1.402-.268-.334-.627-.501-1.075-.501-.462 0-.834.172-1.116.517-.282.343-.423.797-.423 1.362 0 .573.141 1.027.423 1.361.282.332.643.498 1.083.498Z"
      />
    </g>
    <defs>
      <linearGradient
        id="outlook-b"
        x1="7.782"
        x2="21.098"
        y1="14.445"
        y2="6.286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#20A7FA" />
        <stop offset=".4" stopColor="#3BD5FF" />
        <stop offset="1" stopColor="#C4B0FF" />
      </linearGradient>
      <linearGradient
        id="outlook-c"
        x1="12.335"
        x2="19.827"
        y1="17.276"
        y2="5.424"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#165AD9" />
        <stop offset=".501" stopColor="#1880E5" />
        <stop offset="1" stopColor="#8587FF" />
      </linearGradient>
      <linearGradient
        id="outlook-d"
        x1="17.705"
        x2="9.451"
        y1="17.439"
        y2="10.794"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".237" stopColor="#448AFF" stopOpacity="0" />
        <stop offset=".792" stopColor="#0032B1" stopOpacity=".2" />
      </linearGradient>
      <linearGradient
        id="outlook-e"
        x1="16.665"
        x2="29.675"
        y1="20.035"
        y2="11.809"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A43A6" />
        <stop offset=".492" stopColor="#2052CB" />
        <stop offset="1" stopColor="#5F20CB" />
      </linearGradient>
      <linearGradient
        id="outlook-f"
        x1="20.312"
        x2="12.38"
        y1="19.535"
        y2="12.754"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0045B9" stopOpacity="0" />
        <stop offset=".67" stopColor="#0D1F69" stopOpacity=".2" />
      </linearGradient>
      <linearGradient
        id="outlook-h"
        x1="27.998"
        x2="16.538"
        y1="19.289"
        y2="19.289"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4DC4FF" />
        <stop offset=".196" stopColor="#0FAFFF" />
      </linearGradient>
      <linearGradient
        id="outlook-l"
        x1="3.657"
        x2="14.692"
        y1="24.358"
        y2="24.351"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".206" stopColor="#6CE0FF" />
        <stop offset=".535" stopColor="#50D5FF" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="outlook-g"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 -17.2623 18.458 0 16.632 4.506)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".568" stopColor="#275FF0" stopOpacity="0" />
        <stop offset=".992" stopColor="#002177" />
      </radialGradient>
      <radialGradient
        id="outlook-i"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="scale(7.30837 7.39774) rotate(-45 5.293 -1.526)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".259" stopColor="#0060D1" stopOpacity=".4" />
        <stop offset=".908" stopColor="#0383F1" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="outlook-j"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(15.0482 -19.9645 17.8349 13.7738 8.188 29.856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".732" stopColor="#F4A7F7" stopOpacity="0" />
        <stop offset="1" stopColor="#F4A7F7" stopOpacity=".502" />
      </radialGradient>
      <radialGradient
        id="outlook-k"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-7.19389 11.0691 -28.3787 -18.8973 13.202 17.748)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49DEFF" />
        <stop offset=".724" stopColor="#29C3FF" />
      </radialGradient>
      <radialGradient
        id="outlook-m"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(9.08461 9.83507 -9.71625 9.1957 3.964 15.244)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".039" stopColor="#0091FF" />
        <stop offset=".919" stopColor="#183DAD" />
      </radialGradient>
      <radialGradient
        id="outlook-n"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 7.15993 -8.15896 0 9.052 21.08)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".558" stopColor="#0FA5F7" stopOpacity="0" />
        <stop offset="1" stopColor="#74C6FF" stopOpacity=".502" />
      </radialGradient>
      <clipPath id="outlook-a">
        <path fill="#fff" d="M4 4h24v23H4z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
